import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/usersGlobal',
        name: 'usersGlobal',
        component: () => import("./views/usersGlobal.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.SuperAdmin]
        }
    },
    {
        path: '/users',
        name: 'usersCommessa',
        component: () => import("./views/usersCommessa.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/users/:identifier',
        name: 'userDetail',
        component: () => import("./views/userDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
];

export default routes;